import React, {Component} from 'react';
import { Row, Col } from 'react-bootstrap';
import HazyImageHolder from './hazy-image-holder';
import icon from '../assets/gift.svg';

class ThreeColumnGrid extends Component {
  render() {
    return(
      <Row className="le-three-columns-grid">
        <Col md={4}>
          <Row>
            <Col lg={3} xs={3}>
              <HazyImageHolder imgSrc={icon} />
            </Col>
            <Col lg={9} xs={9}>
              <h5>Design Category</h5>
              <p>There is something about this category which is mesmerizing and intimidating</p>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <Row>
            <Col lg={3} xs={3}>
              <HazyImageHolder imgSrc={icon} />
            </Col>
            <Col lg={9} xs={9}>
              <h5>Design Category</h5>
              <p>There is something about this category which is mesmerizing and intimidating</p>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <Row>
            <Col lg={3} xs={3}>
              <HazyImageHolder imgSrc={icon} />
            </Col>
            <Col lg={9} xs={9}>
              <h5>Design Category</h5>
              <p>There is something about this category which is mesmerizing and intimidating</p>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <Row>
            <Col lg={3} xs={3}>
              <HazyImageHolder imgSrc={icon} />
            </Col>
            <Col lg={9} xs={9}>
              <h5>Design Category</h5>
              <p>There is something about this category which is mesmerizing and intimidating</p>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <Row>
            <Col lg={3} xs={3}>
              <HazyImageHolder imgSrc={icon} />
            </Col>
            <Col lg={9} xs={9}>
              <h5>Design Category</h5>
              <p>There is something about this category which is mesmerizing and intimidating</p>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <Row>
            <Col lg={3} xs={3}>
              <HazyImageHolder imgSrc={icon} />
            </Col>
            <Col lg={9} xs={9}>
              <h5>Design Category</h5>
              <p>There is something about this category which is mesmerizing and intimidating</p>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default ThreeColumnGrid;